import { render, staticRenderFns } from "./LeaveAttachmentPreview.vue?vue&type=template&id=b0c1fc0c"
import script from "./LeaveAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports